import { memo } from 'react';
import { LeaguesUnion } from '../../types';
import getLeagueIcon from '../utils/getLeagueIcon';

function LeagueIcon({ league }: { league: LeaguesUnion }) {
  return (
    <div className="h-[inherit] w-[inherit] border-red">
      {getLeagueIcon(league)}
    </div>
  );
}

export default memo(LeagueIcon);
